<template>
  <div ref="elem">{{ value }}</div>
</template>
<script lang="ts" setup>
import mermaid from "mermaid";

const elem = ref<HTMLElement>();

const props = defineProps({
  value: {
    type: String,
    default: 'graph lr\nA-->B'
  }
})

const color = useColorMode();

onMounted(() => {
  mermaid.initialize({
    securityLevel: 'loose',
    startOnLoad: false,
    theme: color.value === 'dark' ? 'dark' : 'default',
  })
  mermaid.parseError = error => console.error(error)

  if (!elem.value) throw new Error('No element');
  mermaid.run({nodes: [elem.value]});
});
</script>
